const name = 'circle-6';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M33.444 26.5c1.436 0 2.569.097 3.397.29.829.193 1.796.483 2.9.87l-.662 4.06c-1.27-.387-2.279-.635-3.025-.746-.745-.11-1.56-.165-2.444-.165-1.326 0-2.458.29-3.397.87a7.89 7.89 0 00-2.32 2.154 11.148 11.148 0 00-1.45 2.858c-.36 1.05-.566 2.044-.622 2.983h.498c.773-1.05 1.657-1.878 2.651-2.485.994-.608 2.127-.912 3.397-.912 2.652 0 4.847.787 6.587 2.362 1.74 1.574 2.61 3.935 2.61 7.084 0 3.093-.994 5.496-2.983 7.208-1.988 1.713-4.446 2.569-7.374 2.569-1.933 0-3.59-.359-4.971-1.077-1.381-.718-2.5-1.685-3.356-2.9-.856-1.215-1.478-2.61-1.864-4.184a20.598 20.598 0 01-.58-4.93c0-3.038.359-5.58 1.077-7.623.718-2.044 1.67-3.687 2.858-4.93 1.188-1.243 2.569-2.113 4.143-2.61a16.274 16.274 0 014.93-.746zm-2.403 14.003c-.994 0-1.92.262-2.775.787a10.147 10.147 0 00-2.196 1.781c0 1.05.055 2.058.166 3.025.11.966.359 1.823.745 2.568.387.746.926 1.34 1.616 1.782.69.442 1.588.663 2.693.663 1.27 0 2.375-.442 3.314-1.326.94-.884 1.409-2.154 1.409-3.812 0-.552-.07-1.16-.207-1.822a4.882 4.882 0 00-.746-1.782c-.359-.525-.87-.967-1.533-1.326-.663-.359-1.491-.538-2.486-.538z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '6',
};

export default icon;
